var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('arena-channel-thumbs',{attrs:{"channelSlug":_vm.channelSlug,"textFilter":_vm.$route.query.filter}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }